/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to update the name of week models
 * @export
 * @interface WeekModelUpdateNameRequest
 */
export interface WeekModelUpdateNameRequest {
    /**
     * New name of week model
     * @type {string}
     * @memberof WeekModelUpdateNameRequest
     */
    newName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WeekModelUpdateNameRequest
     */
    weekModelIds?: Array<string>;
}

/**
 * Check if a given object implements the WeekModelUpdateNameRequest interface.
 */
export function instanceOfWeekModelUpdateNameRequest(value: object): value is WeekModelUpdateNameRequest {
    return true;
}

export function WeekModelUpdateNameRequestFromJSON(json: any): WeekModelUpdateNameRequest {
    return WeekModelUpdateNameRequestFromJSONTyped(json, false);
}

export function WeekModelUpdateNameRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeekModelUpdateNameRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'newName': json['newName'] == null ? undefined : json['newName'],
        'weekModelIds': json['weekModelIds'] == null ? undefined : json['weekModelIds'],
    };
}

export function WeekModelUpdateNameRequestToJSON(json: any): WeekModelUpdateNameRequest {
    return WeekModelUpdateNameRequestToJSONTyped(json, false);
}

export function WeekModelUpdateNameRequestToJSONTyped(value?: WeekModelUpdateNameRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newName': value['newName'],
        'weekModelIds': value['weekModelIds'],
    };
}

